module.exports = __webpack_public_path__ + "img/motherwell-fc.509cf660.png";